import {
  RECENT_MQL_PLUS_LEADS_COMPLETED,
  RECENT_MQL_PLUS_LEADS_FAILED,
  RECENT_MQL_PLUS_LEADS_REQUESTED
} from '../actions/GetRecentMqlPlusLeads';

const initialState = {
  loading: true,
  data: {},
};

const recentMqlPlusLeads = (state = initialState, action) => {
  switch (action.type) {
    case RECENT_MQL_PLUS_LEADS_REQUESTED:
      return initialState;
    case RECENT_MQL_PLUS_LEADS_COMPLETED:
      return {
        data: action.data,
        loading: false,
      };
    case RECENT_MQL_PLUS_LEADS_FAILED:
      return Object.assign({}, initialState, {
        loading: false,
      });
    default:
      return state;
  }
};

export default recentMqlPlusLeads;
